var custom = {
  init: function(){
    custom.sliderHome();
    custom.countDown();
    custom.sidebarStickitCustom();
    custom.selectChange();
  },
  sliderHome: function(){
    if($(".slider-home").length){
      $('.slider-home').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear'
      });
      $('.slider-home').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.slider-info').removeClass('aos-init').removeClass('aos-animate');
      });
      $('.slider-home').on('afterChange', function(event, slick, currentSlide, nextSlide){
        AOS.refresh();
      });
    }
  },
  countDown: function(){
    if($(".listTiempo").length){
      $('[data-countdown]').each(function () {
        var $this = $(this), finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function (event) {
            $this = $(this).html(event.strftime(''
            + '<div><span class="datos-tiempo">%D</span><em>Días</em></div>'
            + '<div><span class="datos-tiempo">%H</span><em>Horas</em></div>'
            + '<div><span class="datos-tiempo">%M</span><em>Min</em></div>'
            + '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            ));
        });
      });
    }
  },
  sidebarStickitCustom: function(){
    if($('.sidebar-stickit-custom').length){
      $('.sidebar-stickit-custom').stickit({
        screenMinWidth: 992,
        top: 60
      });
    }  
  },
  toggleUserCourse: function(e){
    if($(".info-text-autor").hasClass("toggle-active")){
      $(".toggle-click").removeClass("a-toggle");
      $(".info-text-autor").removeClass("toggle-active");
    }else{
      $(".toggle-click").addClass("a-toggle");
      $(".info-text-autor").addClass("toggle-active");
    }
  },
  selectChange: function(){
    $('#selectCategory').on('change', function() {
      var url = $(this).val();
      if (url) {
        window.location = url;
      }
      return false;
    });
  }
}
